import useData from "storefront/hooks/data/useData";

import getUserDecisions, {
  CACHE_KEY,
} from "storefront/GrailedAPI/v1/Sift/getUserDecisions";
import useAuthentication from "storefront/hooks/useAuthentication";

export const useUserDecisions = () => {
  const auth = useAuthentication();
  const userDecisionsResource = useData(getUserDecisions, {
    key: CACHE_KEY,
    shouldFetch: auth.type === "Authenticated",
  });

  if (userDecisionsResource.type !== "Completed") {
    return null;
  }

  return userDecisionsResource.value;
};
